<template>
  <div class="message-body" :class="[senderType == 'user' ? 'color-theme-default' : '']">
    <a :href="(image.thumbnail_url || image.url) | absURL" target="_blank">
        <img :src="(image.thumbnail_url || image.url) | absURL" :onload="onLoad()">
    </a>
  </div>
</template>

<script>
export default {
  props: ['image', 'senderType'],

  methods: {
    onLoad () {
      this.$emit('loaded')
    }
  }
}
</script>
